import { Grid } from '@mui/material';
import { KeySearchParamsEnum } from 'enums';
import useFilter from 'hooks/useFilter';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { useMemo } from 'react';
import { Wallet } from 'types/wallet';
import CircleLoading from 'ui-component/CircleLoading';
import CoinCard from './CoinCard';

const CoinList = ({ data, isLoading }: { data: Wallet[]; isLoading: boolean }) => {
    const { handleSetFilter, getValueFilter, dependenciesEffect } = useFilter();

    const currentToken = useMemo(() => {
        const token = getValueFilter(KeySearchParamsEnum.TOKEN);
        return token ?? _get(data, '[0].symbol', null);
    }, [dependenciesEffect, data]);

    const handleClickItem = (symbol: string) => {
        handleSetFilter([{ key: KeySearchParamsEnum.TOKEN, value: symbol }]);
    };

    return (
        <Grid container flexDirection="column" gap={2} position="relative" minHeight={300}>
            {isLoading ? <CircleLoading /> : null}
            {_map(data, (item) => (
                <Grid item xs={12} key={item.symbol}>
                    <CoinCard isLoading={isLoading} data={item} onClick={handleClickItem} selected={currentToken === item.symbol} />
                </Grid>
            ))}
        </Grid>
    );
};

export default CoinList;
